// src/components/CommitteeAccordion.jsx
import { useRef, useState, useLayoutEffect, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import "./Accordian.css";

function AccordionSection({ id, title, openId, setOpenId, children }) {
  const isOpen = openId === id;
  const ref = useRef(null);
  const [height, setHeight] = useState(0);

  // measure content height
  useLayoutEffect(() => {
    if (isOpen && ref.current) setHeight(ref.current.scrollHeight);
  }, [isOpen, children]);

  // resize recalculation
  useEffect(() => {
    if (!isOpen) return;
    const onResize = () => ref.current && setHeight(ref.current.scrollHeight);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [isOpen]);

  const toggle = () => setOpenId(isOpen ? null : id);

  return (
    <div className="accordion-section">
      <button
        className="accordion-header"
        onClick={toggle}
        aria-expanded={isOpen}
        aria-controls={`${id}-panel`}
      >
        <span>{title}</span>
        <ChevronDownIcon
          className={`accordion-icon ${isOpen ? "open" : ""}`}
        />
      </button>

      <div
        id={`${id}-panel`}
        className="accordion-body"
        style={{ height: isOpen ? height : 0 }}
      >
        <div ref={ref} className="accordion-inner">
          {children}
        </div>
      </div>
    </div>
  );
}

export default function CommitteeAccordion({ PNG }) {
  const [openId, setOpenId] = useState(null);

  return (
    <div className="committee-wrapper">
      {/* ===== Organizing Secretary ===== */}
      <AccordionSection
        id="secretary"
        title="Organizing Secretary"
        openId={openId}
        setOpenId={setOpenId}
      >
        <div className="card">
          <div className="card-text">
            <h2>Shilpi Sharma</h2>
            <p>
              Professor, Dept. of Biochemical Engineering &amp; Biotechnology <br />
              Associate Dean Academics (Outreach &amp; New Initiatives)
            </p>
            <p className="inst-name">
              Indian Institute of Technology Delhi
            </p>
          </div>

          <div className="card-img">
            <img
              src={PNG?.shilpi}
              alt="Prof. Shilpi Sharma"
            />
          </div>
        </div>
      </AccordionSection>

      {/* ===== Organizing Team ===== */}
      <AccordionSection
        id="team"
        title="Organizing Team"
        openId={openId}
        setOpenId={setOpenId}
      >
        <ul className="team-list">
          <li><strong>Ann Francis</strong>, Professor, Dept. of Civil Engineering</li>
          <li><strong>Deepti Gupta</strong>, Professor, Dept. of Textile &amp; Fibre Engineering</li>
          <li><strong>Manidipa Banerjee</strong>, Professor, Kusuma School of Biological Sciences</li>
          <li><strong>Maya Ramanath</strong>, Professor, Dept. of Computer Science &amp; Engineering</li>
          <li><strong>Ravinder Kaur</strong>, Professor Emeritus, Humanities &amp; Social Sciences</li>
          <li><strong>Rijurekha Sen</strong>, Professor, Dept. of Computer Science &amp; Engineering</li>
          <li><strong>Saksham Saraswat</strong>, Office of Academic Outreach &amp; New Initiatives</li>
          <li><strong>Shivani Kush</strong>, Office of Academic Outreach &amp; New Initiatives</li>
          <li><strong>Shuchi Sinha</strong>, Professor, Dept. of Management Studies; Associate Dean (Faculty)</li>
          
        </ul>
      </AccordionSection>
    </div>
  );
}
